<div
  class="cv-page cv9"
  [ngClass]="{ 'thumbnail-view': isThumbnail }"
>
  <div class="cv-frame">
    <!-- LEFT CONTENT -->
    <main class="left-col">
      <section class="experience">
        <h3 class="section-title blue">WORK EXPERIENCE</h3>
        <div
          class="exp-item"
          *ngFor="let exp of data.experience"
        >
          <h4 class="job-title">{{ exp.Title }}</h4>
          <div class="company-line">
            <span class="company">{{ exp.company }}</span>
          </div>
          <p class="dates-location">
            {{ exp.startDate }} - {{ exp.endDate || 'Current' }}
            <span *ngIf="exp.joblocation?.City || exp.joblocation?.State">
              | {{ exp.joblocation?.City
              }}{{ exp.joblocation?.City && exp.joblocation?.State ? ', ' : ''
              }}{{ exp.joblocation?.State }}
            </span>
          </p>
          <ul class="description-points">
            <li *ngFor="let point of exp.descriptionPoints">{{ point }}</li>
          </ul>
        </div>
      </section>
    </main>

    <!-- RIGHT SIDEBAR -->
    <aside class="right-col">
      <header class="profile-header">
        <h1 class="name">
          {{ data.firstName | uppercase }} {{ data.lastName | uppercase }}
        </h1>
        <p
          class="designation"
          *ngIf="data.designation"
        >
          {{ data.designation }}
        </p>
      </header>

      <div class="contact">
        <p *ngIf="data.contactDetails?.email">
          ✉ {{ data.contactDetails.email }}
        </p>
        <p *ngIf="data.contactDetails?.number">
          📞 {{ data.contactDetails.number }}
        </p>
        <p *ngIf="data.contactDetails?.address">
          📍 {{ data.contactDetails.address || data?.city }}
        </p>
        <p *ngIf="data.contactDetails?.linkedIn">
          in {{ data.contactDetails.linkedIn }}
        </p>
      </div>

      <section
        class="objective"
        *ngIf="data.about"
      >
        <h3 class="section-title">OBJECTIVE</h3>
        <p>{{ data.about }}</p>
      </section>

      <section
        class="education"
        *ngIf="data.educations?.length"
      >
        <h3 class="section-title">EDUCATION</h3>
        <div
          *ngFor="let edu of data.educations"
          class="edu"
        >
          <div class="degree">{{ edu.courseName }}</div>
          <div class="uni">{{ edu.universityName }}</div>
          <div class="timeline">{{ edu.formattedDate }}</div>
          <div
            class="location"
            *ngIf="edu.location"
          >
            {{ edu.location }}
          </div>
        </div>
      </section>

      <section
        class="skills"
        *ngIf="data.skills?.length"
      >
        <h3 class="section-title">SKILLS</h3>
        <ul>
          <li *ngFor="let skill of data.skills">{{ skill }}</li>
        </ul>
      </section>

      <section
        class="certs"
        *ngIf="data.certifications?.length"
      >
        <h3 class="section-title">CERTS</h3>
        <ul>
          <li *ngFor="let cer of data.certifications">
            <span *ngIf="cer.name">{{ cer.name }}</span>
            <span *ngIf="cer.authority"> ({{ cer.authority }})</span>
          </li>
        </ul>
      </section>
    </aside>
  </div>
</div>
